import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=4c0b48c2&scoped=true&"
import script from "./AddIcon.vue?vue&type=script&lang=js&"
export * from "./AddIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddIcon.vue?vue&type=style&index=0&id=4c0b48c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b48c2",
  null
  
)

export default component.exports